import React from "react"
import { Link } from "gatsby"

import sonerion from "../images/sonerion.png"
import montfort from "../images/montfort2.png"
import logo from "../images/logo-dark.svg"
import * as styles from "./footer.module.scss"

const socials = [
    { href: "mailto:contact@bagadmenru.bzh", icon: "fas fa-at", label: "E-mail" },
    { href: "https://www.facebook.com/BagadMenRu", icon: "fab fa-facebook-f", label: "Facebook" },
    { href: "https://www.instagram.com/bagadmenru", icon: "fab fa-instagram", label: "Instagram" },
    { href: "https://www.youtube.com/channel/UCXeTfDjXSVWYNIbC4NQQ9SQ", icon: "fab fa-youtube", label: "YouTube" },
]

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className="container">
                <Link to="/" className={styles.wordmark}>
                    <img src={logo} alt="" className={styles.mark}/>
                    <span className="display">Bagad Men Ru</span>
                </Link>

                <div className={styles.grid}>
                    <div className={styles.brand}>
                        <p>
                            Ensemble traditionnel breton de Montfort-sur-Meu, membre de la fédération Sonerion
                            et du <a href="https://cerclemontfortais.org" className={styles.inline}>Cercle Montfortais</a>.
                        </p>
                        <div className={styles.socials}>
                            {socials.map(s =>
                                <a key={s.href} href={s.href} aria-label={s.label} title={s.label}>
                                    <span className={s.icon} aria-hidden="true"/>
                                </a>
                            )}
                        </div>
                    </div>

                    <div>
                        <h4 className={`fiche ${styles.heading}`}>Le site</h4>
                        <ul className={styles.list}>
                            <li><Link to="/">Accueil</Link></li>
                            <li><Link to="/blog/">Actualités</Link></li>
                            <li><Link to="/timeline/">Le Bagad</Link></li>
                            <li><Link to="/ecole-de-musique/">L'école de musique</Link></li>
                            <li><Link to="/cercle-montfortais/">L'association</Link></li>
                            <li><Link to="/contact/">Contact</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className={`fiche ${styles.heading}`}>Nous trouver</h4>
                        <address className={styles.address}>
                            <a href="https://cerclemontfortais.org" className={styles.inline}>Cercle Montfortais</a> – Bagad Men Ru<br/>
                            Mairie<br/>
                            35160 Montfort-sur-Meu
                        </address>
                        <a href="mailto:contact@bagadmenru.bzh" className={styles.mail}>contact@bagadmenru.bzh</a>
                        <a href="https://membres.bagadmenru.bzh/" className={`btn btn-outline-white btn-sm ${styles.members}`}>
                            <span className="fas fa-lock me-2" aria-hidden="true"/>Espace membres
                        </a>
                    </div>
                </div>

                <div className={styles.bottom}>
                    <div className={styles.partners}>
                        <a href="https://sonerion.bzh" title="Sonerion"><img src={sonerion} alt="Sonerion"/></a>
                        <a href="https://www.montfort-sur-meu.bzh" title="Montfort-sur-Meu"><img src={montfort} alt="Montfort-sur-Meu"/></a>
                    </div>
                    <div className={styles.copy}>
                        © {new Date().getFullYear()} Bagad Men Ru · Made with <span className="fa fa-heart" aria-label="amour"/> by Mael G.
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
